import types from '@/vuex/auth/actions-types'
// import auth from '@/utils/auth'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const actions = {
  [types.SET_LOGGED_IN]: ({ commit }) => {
    commit(types.SET_LOGGED_IN)
  },
  [types.UNSET_LOGGED_IN]: ({ commit }) => {
    commit(types.UNSET_LOGGED_IN)
  },
  [types.SET_USERNAME]: ({ commit }, payload) => {
    commit(types.SET_USERNAME, payload)
  },
  [types.UNSET_USERNAME]: ({ commit }) => {
    commit(types.UNSET_USERNAME)
  },
  [types.SET_NOME]: ({ commit }, payload) => {
    commit(types.SET_NOME, payload)
  },
  [types.UNSET_NOME]: ({ commit }) => {
    commit(types.UNSET_NOME)
  },
  [types.SET_VINCULO]: ({ commit }, payload) => {
    commit(types.SET_VINCULO, payload)
  },
  [types.UNSET_VINCULO]: ({ commit }) => {
    commit(types.UNSET_VINCULO)
  },
  [types.SET_ADMINISTRADOR]: ({ commit }, payload) => {
    commit(types.SET_ADMINISTRADOR, payload)
  },
  [types.UNSET_ADMINISTRADOR]: ({ commit }) => {
    commit(types.UNSET_ADMINISTRADOR)
  },
  [types.SET_USUARIO_PROEX]: ({ commit }, payload) => {
    commit(types.SET_USUARIO_PROEX, payload)
  },
  [types.UNSET_USUARIO_PROEX]: ({ commit }) => {
    commit(types.UNSET_USUARIO_PROEX)
  },
  [types.SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO]: ({ commit }, payload) => {
    commit(types.SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, payload)
  },
  [types.UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO]: ({ commit }) => {
    commit(types.UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO)
  },
  [types.PERFORM_LOGOUT]: ({ commit }) => {
    commit(types.UNSET_USERNAME)
    commit(types.UNSET_LOGGED_IN)
    commit(types.UNSET_NOME)
    commit(types.UNSET_VINCULO)

    window.location = encodeURI(API_URL + '/logout')
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/auth/actions.js